module.exports = __webpack_public_path__ + "img/door5.41332b64.png";